// Copy shown before a queue is deleted.
//
// It describes DELETE /service_types as that endpoint actually behaves on the branch this panel
// depends on (ticketing-backend sdd-booking-prefix-sms, routes/api/service_types/):
//   * evaluate_service_type_deletion() REFUSES the delete when the queue is a reserved system
//     prefix, still holds waiting tickets, or is referenced by a kiosk menu route, a booking
//     import profile, a booking, or a historical ticket. Nothing is cascade-deleted in those
//     cases; the request comes back with the reason, which the store shows verbatim.
//   * On success delete_service_type_guarded() removes the in-memory queue bucket inside the
//     same transaction and persists queues.json, then the controller broadcasts the update — so
//     there is NO leftover bucket and no reason to run "Reset Current Queues" afterwards (that
//     button clears every live queue in the building).
//   * The only side effects that survive the guard are the two the response reports: operator
//     skillset assignments are cascade-deleted, and past SMS logs keep their content but lose
//     their queue association.
// Extracted from QueueSetting.vue so it can be asserted against that contract
// (tests/queueDelete.test.mjs) instead of only being read.
export function queueDeleteConfirmMessage(label) {
  return (
    `Delete queue "${label}"?\n\n` +
    'The server refuses the delete if the queue still has waiting tickets, or is used by a kiosk ' +
    'menu route, a booking import profile, a booking, or a past ticket — nothing is removed in ' +
    'that case, and it will tell you what to clear first.\n\n' +
    'If it does go through: operator skillset assignments for this queue are removed, past SMS ' +
    'logs keep their content but lose their queue link, and the live queue is closed immediately.' +
    '\n\nThis cannot be undone.'
  )
}
